export default "__VITE_ASSET__DVRteVSK__"